import React from "react";

function TopRunScorers({ players, loading }) {
    const maxRuns = players.length > 0 ? players[0].runs : 1;

    const getInitials = (name) => {
        if (!name) return "?";
        return name.split(" ").map(n => n[0]).join("").substring(0, 2).toUpperCase();
    };

    return (
        <div className="sfull">
            <div className="sfh">Top Run Scorers - Last week</div>
            {loading ? (
                <div className="sfull-empty">Loading...</div>
            ) : players.length === 0 ? (
                <div className="sfull-empty">No data available</div>
            ) : players.map((player, index) => (
                <div className="psrow" key={player.playerId}>
                    <div className={`psrk ${index === 0 ? "t" : ""}`}>{index + 1}</div>
                    <div className="psav">
                        {player.pictureURL ? (
                            <img src={player.pictureURL} alt={player.name}
                                 className="psav-img"
                                 onError={(e) => { e.target.style.display = "none"; e.target.parentNode.innerHTML = `<div class="pav-initials pav-initials-sm">${getInitials(player.name)}</div>`; }}
                            />
                        ) : (
                            <div className="pav-initials pav-initials-sm">{getInitials(player.name)}</div>
                        )}
                    </div>
                    <div className="psd">
                        <div className="psname">{player.name}</div>
                        <div className="psteam">{player.teamName || ""}</div>
                        <div className="bar-w">
                            <div className="bar-l" style={{ width: `${(player.runs / maxRuns) * 100}%` }}></div>
                        </div>
                    </div>
                    <div className="psval l">{player.runs?.toLocaleString()}</div>
                </div>
            ))}
        </div>
    );
}

export default TopRunScorers;